import React, { useContext } from 'react';
import { ErrorContext } from './index';

const ErrorPage = () => {
  const { errorMessage } = useContext(ErrorContext);
  const message = errorMessage || "Bilinmeyen bir hata oluştu";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#d40000",
        color: "#ffffff",
        textAlign: "center",
        padding: "1rem",
      }}
    >
      <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>{message}</h1>
    </div>
  );
};
export default ErrorPage;
